import { ApplicationBreakpoint, AttributionType, RootState } from "../types";

export const getHeaderTitle = (state: RootState): string => state.app.headerTitle;

export const getAttribution = (state: RootState): AttributionType => state.app.attributionType;

export const getAppBreakpointState = (state: RootState): ApplicationBreakpoint => state.app.appBreakpoint;

export const getJwt = (state: RootState): string | null => state.app.jwt;
